import { render } from "./BuyKeypad.vue?vue&type=template&id=0c6ccd92&scoped=true&ts=true"
import script from "./BuyKeypad.vue?vue&type=script&lang=ts"
export * from "./BuyKeypad.vue?vue&type=script&lang=ts"

import "./BuyKeypad.vue?vue&type=style&index=0&id=0c6ccd92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6ccd92"]])

export default __exports__